import {PathProps} from "../../shared";
import {Lesson} from "../practice/types";
import React, {ReactElement, useEffect, useState} from "react";
import {Box, ButtonBase, Grid, Typography} from "@mui/material";
import {BORDER_RADIUS_MEDIUM, DIVIDER, PAGE_FRAGMENT_LG_WIDTH, PD_LG} from "../../shared/dimens";
import {BaseApp} from "../../shared/BaseApp";
import {LessonDialogFragment} from "../practice/LessonDialogFragment";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "../../shared/StyledComponents";
import {Avatar} from "../avatarmaker/avatar";
import {CHAT_PERSONA_APPEARANCE_KTM} from "../types";
import {ChatPersona} from "../../toktiv-common/types";
import {AppPrefs} from "../app_prefs";

export function ContainerWithTitle(props: {
  title: string,
  titleStyle?: any,
  children: any,
  accessory?: ReactElement
}): ReactElement {
  return <StyledBoxColumn>
    <StyledBoxRow style={{alignItems: "center"}}>
      <Typography variant="h5" style={props.titleStyle}>{props.title}</Typography>
      <StyledSpan/>
      {props.accessory}
    </StyledBoxRow>
    {props.children}
  </StyledBoxColumn>;
}

export function AvatarImage(props: { persona: ChatPersona, flip: boolean, style?: any }): ReactElement {
  const appearance = CHAT_PERSONA_APPEARANCE_KTM.findMetadata(props.persona.type);
  const [imageData, setImageData] = useState<string>();
  useEffect(() => {
    const imageData = AppPrefs.getInstance().getImageData(props.persona.type);
    if (imageData) {
      setImageData(imageData);
    } else {
      Avatar.generateImageDataUrl(appearance.avatarConfig, appearance.color)
        .then(imageData => setImageData(imageData));
    }
  }, []);
  return <img
    src={imageData}
    style={{
      ...props.style,
      transform: `scale(${props.flip ? -1: 1}, 1)`,
      aspectRatio: 1,
    }}
  />;
}

export function LessonsGrid(props: { path: PathProps, lessons: Lesson[] }): ReactElement {
  return <Box style={{
    display: "flex",
    maxWidth: PAGE_FRAGMENT_LG_WIDTH,
    margin: "auto",
    width: "100%",
    flexDirection: "column",
    flexGrow: 1,
    overflowY: "scroll",
    padding: PD_LG
  }}>
    <Grid container spacing={2}>
      {props.lessons.map(lesson => <Grid item xs={6} sm={4} md={3}>
        <ButtonBase
          style={{width: "100%"}}
          onClick={() => BaseApp.CONTEXT.showFullscreenDialog(() =>
            <LessonDialogFragment path={props.path} lessonId={lesson.id}/>)}>
          <StyledBoxColumn
            style={{
              borderRadius: BORDER_RADIUS_MEDIUM,
              border: DIVIDER,
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 0,
              width: "100%",
              aspectRatio: 1,
              background: lesson.background,
              paddingBottom: 8,
            }}>
            {lesson.titleLines.map(line => <Typography variant="h4" style={{
              padding: 4,
              paddingLeft: 8,
              paddingRight: 8,
              background: "white",
              transform: "rotate(-5deg)"
            }}>{line}</Typography>)}
          </StyledBoxColumn>
        </ButtonBase>
      </Grid>)}
    </Grid>
  </Box>;
}